<svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 16 16" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none">
  <path d="M2,6L2,2L6,2M10,2L14,2L14,6M14,10L14,14L10,14M6,14L2,14L2,10" stroke="currentColor" />
  <path d="M1,8L7,8" stroke="currentColor" />
  <path d="M5,6L7,8L5,10" stroke="currentColor" />
  <path d="M11,10L9,8L11,6" stroke="currentColor" />
  <path d="M15,8L9,8" stroke="currentColor" />
</svg>
